// Quién imparte un servicio (grupos y negocios).
// El servidor manda `imparte` en los listados (e `imparten` en la ficha) cuando el servicio lo imparte otra persona que ya aceptó.
// El proveedor (`userId`) sigue siendo quien lo creó: con él se abre la ficha, se reserva y se cotiza.
import { urlImg, isEmpty } from './helpers';

export const nombreDe = (persona) => [persona?.name, persona?.apellido].filter(Boolean).join(' ').trim();

// Foto de una persona ({ _id, avatar, versionAvatar }): acepta avatares de redes (http…) y los de Cloudinary. '' si no tiene.
export const fotoDe = (persona, medida = 'w_80,h_80,c_fill') => {
  if (!persona || isEmpty(persona.avatar)) return '';
  const avatar = String(persona.avatar);
  if (avatar.startsWith('http')) return avatar;
  if (avatar.startsWith('//')) return avatar.replace(/^\/\//, 'https://');
  const version = persona.versionAvatar ? `v${persona.versionAvatar}/` : '';
  return `${urlImg}/${medida}/${version}users/${persona._id}/${avatar}`;
};

// Elemento de un listado con el autor que la tarjeta debe mostrar. Si lo imparte otra persona, `author`, `authorName`,
// `authorAvatar` y `authorAvatarVersion` pasan a ser los suyos. `autorId` dice de quién son (su foto y su perfil);
// `userId` no cambia.
export const conQuienImparte = (item) => {
  if (!item) return item;
  const persona = item.imparte;
  if (!persona || !persona._id) return { ...item, autorId: item.userId };
  const nombre = nombreDe(persona);
  return {
    ...item,
    author: nombre,
    authorName: nombre,
    authorAvatar: persona.avatar,
    authorAvatarVersion: persona.versionAvatar,
    autorId: persona._id,
  };
};

// Estado de quien imparte, como lo ve el dueño (pagina.servicios[].estadoFacilitador y servicio.facilitador.estado).
// Colores del tema; el texto del chip va en azul oscuro para que se lea sobre cualquiera de los tres.
export const ESTADO_FACILITADOR = {
  pendiente: { etiqueta: 'Pendiente de aceptar', color: 'warning.main' },
  aceptado: { etiqueta: 'Aceptó', color: 'success.main' },
  rechazado: { etiqueta: 'Rechazó', color: 'error.main' },
};

// Mientras la persona no acepta (o si rechazó), el servicio no se ve ni se puede contratar.
export const esperaFacilitador = (estado) => estado === 'pendiente' || estado === 'rechazado';
